"use client";

import { c as _c } from "react/compiler-runtime";
import { cx } from "@/utils/cx";
const sizes = {
  xs: "size-1.5",
  sm: "size-2",
  md: "size-2.5",
  lg: "size-3",
  xl: "size-3.5",
  "2xl": "size-4",
  "3xl": "size-4.5",
  "4xl": "size-5"
};
interface AvatarOnlineIndicatorProps {
  size: "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl";
  status: "online" | "offline";
  className?: string;
}
export const AvatarOnlineIndicator = t0 => {
  const $ = _c(6);
  const {
    size,
    status,
    className
  } = t0;
  const t1 = status === "online" ? "bg-fg-success-secondary" : "bg-fg-disabled_subtle";
  const t2 = sizes[size];
  let t3;
  if ($[0] !== className || $[1] !== t1 || $[2] !== t2) {
    t3 = cx("absolute right-0 bottom-0 rounded-full ring-[1.5px] ring-bg-primary", t1, t2, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <span className={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};